import { preview } from '@/components/form/preview'

import { useDeleteUserConfirmationModal } from '../modals/DeleteUserConfirmationModal'
import { useChangePasswordModal } from '../modals/ChangePasswordModal'
import { useDisableUserConfirmationModal } from '../modals/DisableUserConfirmationModal'

import { ViewHeader } from './ViewHeader'
import { ViewDetails } from './ViewDetails'

type Props = {
  user: uui.domain.client.rm.RouteManagerUser
  selectedUsers: uui.domain.client.rm.RouteManagerUser[]
}

export function ViewUser(props: Props) {
  const { user } = props

  const { Modal: DeleteUserConfirmationModal } = useDeleteUserConfirmationModal()
  const { Modal: ChangePasswordModal } = useChangePasswordModal()
  const { Modal: DisableUserConfirmationModal } = useDisableUserConfirmationModal()

  return (
    <preview.Root applyPendingFitMapOnMount header={<ViewHeader {...props} />}>
      <ViewDetails {...props} />

      <DeleteUserConfirmationModal userIds={[user.id]} />
      <ChangePasswordModal userId={user.id} />
      <DisableUserConfirmationModal userId={user.id} />
    </preview.Root>
  )
}
